import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    MOCKUPS: "Php",
    VIMEO: "Java",
  };

  const types = {
    IMAGE: "image",
    VIDEO: "video",
    DOCUMENT: "document",
  };

  const projectsData = [
    
    {
      title: "BIENES RAICES",
      type: types.DOCUMENT,
      document: {
        projectInfo:
        "Website for a real estate business, in which technology Saas has been used together with Gulp and JavaScript in the front-end to implement the styles and additional functions, such as the dark mode of the website. For the back-end, PHP was used to create a Model-View-Controller (MVC) framework. The website has a distinction between a public area and a private area. This allows users to securely and easily access the administration of the website, thanks to the inclusion of validations and restrictions on the private pages. This ensures a secure and controlled environment for the management of the platform.",
        client: "Personal project",
        technologies: "PHP, Sass, HTML, Gulp, JavaScript, MySQL, MVC",
        url: {
          name: "Github",
          link: "https://github.com/Rubi76X/bienes-raices",
        },

        sliderImages: [
          "images/projects/2-bienes-raices.png",
          "images/projects/3-bienes-raices.png",
          "images/projects/4-bienes-raices.png",
          "images/projects/5-bienes-raices.png",
          "images/projects/6-bienes raices.png",
        ],
      },

      thumbImage: "images/projects/1-bienes-raices.png",

      categories: [filters.MOCKUPS],
    },
    
    
    
    {
      title: "Dr. Lomito",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "The e-commerce Dr. Lomito is a space to find veterinary specialists. In the project we worked on the front-end and back-end, during its development we held daily meetings and with the help of the SCRUM methodology as well as Trello, Discord and Whatsapp, allowed us to manage tasks, activities and communication.",
        client: "Generation México",
        technologies: "HTML, CSS, JavaScript, Bootstrap, Java, Spring Boot, SQL, MySQL, GitHub, Git",
        
        
        url: {
          name: "GitHub",
          link: "https://github.com/Rubi76X/ProyectoIntegradorG",
        },
        

        sliderImages: [
          "images/projects/lomito-2.jpg",
          "images/projects/lomito-3.png",
          "images/projects/lomito-4.jpg",
          "images/projects/lomito-5.jpg",
          "images/projects/lomito-6.jpg",
          "images/projects/lomito-7.png",
          "images/projects/lomito-8.jpg",
          "images/projects/lomito-9.jpg",
        ],
      },

      thumbImage: "images/projects/lomito-1.jpg",

      categories: [filters.VIMEO],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-blanco px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Some of my most recent projects
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " + (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div 
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="bi bi-file-earmark-code-fill text-blanco" ></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fas fa-image"></i>
                              )}
                              {project.type === types.VIDEO && (
                                <i className="fas fa-video"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Web Developer</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
